import {
  Input,
  Output,
  Component,
  EventEmitter,
} from '@angular/core';

import { IProductTypeListMode, UiContextService } from '@cakeiteasy/web-utils';

import { isModalClickIgnored } from '../../helpers';

@Component({
  standalone: false,
  selector: 'request-form-type',
  templateUrl: './request-form-type.component.html',
})
export class RequestFormTypeComponent {
  @Input() productType: IProductTypeListMode;
  @Input() showImage: boolean;

  @Output() showModal = new EventEmitter<{ productType: IProductTypeListMode }>();

  constructor(public uiContext: UiContextService) {
  }

  public onShowModal() {
    this.showModal.emit({
      productType: this.productType,
    });
  }

  public onProductTypeClick(event: MouseEvent) {
    if (isModalClickIgnored(event)) {
      return;
    }

    this.onShowModal();
  }
}
